<script setup lang="ts">
import { computed } from "vue";
type Props = {
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  required: false,
  error: false,
  disabled: false,
});

const textClass = computed(() => {
  if (props.disabled) {
    return "text-gray-400";
  }
  if (props.error) {
    return "text-link-red";
  }
  return "text-gray-700";
});
</script>

<template>
  <label class="text-md block text-left font-bold" :class="textClass">
    <slot />
    <span v-if="props.required" class="text-red-800"> *</span>
  </label>
</template>
